.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  border: 1px solid transparent;
  border-radius: var(--radius-button);
  font-weight: var(--weight-bold);
  line-height: 1;
  white-space: nowrap;
  transition:
    transform var(--duration-fast) var(--ease-standard),
    background-color var(--duration-fast) var(--ease-standard),
    border-color var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard),
    box-shadow var(--duration-fast) var(--ease-standard);
}

.button svg {
  flex: none;
  width: 17px;
  height: 17px;
}

.button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.button:active:not(:disabled) {
  transform: none;
}

.button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
}

/* ---- variants ---- */

.primary {
  background-color: var(--color-brand);
  color: var(--color-text-on-brand);
  box-shadow: var(--shadow-brand);
}

.primary:hover:not(:disabled) {
  background-color: var(--color-brand-hover);
}

.secondary {
  background-color: var(--color-brand-subtle);
  border-color: var(--color-brand-tint);
  color: var(--color-brand-strong);
}

.secondary:hover:not(:disabled) {
  background-color: color-mix(in srgb, var(--color-brand) 15%, var(--color-surface));
}

.ghost {
  background-color: transparent;
  border-color: var(--color-border);
  color: var(--color-text);
}

.ghost:hover:not(:disabled) {
  border-color: var(--color-border-strong);
  background-color: var(--color-surface);
}

.danger {
  background-color: color-mix(in srgb, var(--color-danger) 9%, var(--color-surface));
  border-color: color-mix(in srgb, var(--color-danger) 20%, var(--color-border));
  color: var(--color-danger-text);
}

.danger:hover:not(:disabled) {
  background-color: color-mix(in srgb, var(--color-danger) 14%, var(--color-surface));
}

/* ---- sizes ---- */

.sm {
  min-height: var(--control-height-sm);
  padding: 0 var(--space-3);
  border-radius: var(--radius-sm);
  font-size: var(--text-xs);
}

.sm svg {
  width: 15px;
  height: 15px;
}

.md {
  min-height: var(--control-height-md);
  padding: 0 var(--space-4);
  font-size: var(--text-sm);
}

.lg {
  min-height: var(--control-height-xl);
  padding: 0 var(--space-5);
  font-size: var(--text-base);
}

.fullWidth {
  width: 100%;
}

.spinner {
  width: 1em;
  height: 1em;
  border: 2px solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: button-spin 0.6s linear infinite;
}

@keyframes button-spin {
  to {
    transform: rotate(360deg);
  }
}
